import { useCallback, useMemo, useState } from 'react';

import {
    AuditTrailFilterValue,
    AuditTrailTimeframeOptions,
    DEFAULT_AUDIT_TRAIL_FILTERS,
} from '../../models/activty-log.model';

import useHandleQueryParams from '../helper/useHandleQueryParams';

export type AuditTrailFilterMode = 'url' | 'local';

/** Timeframe/person filter state, kept in the URL (full pages) or in component state (drawers). */
export default function useAuditTrailFilterState(
    mode: AuditTrailFilterMode,
): [
    AuditTrailFilterValue,
    (field: keyof AuditTrailFilterValue, value: string) => void,
] {
    const [queryParams, setQueryParams] = useHandleQueryParams();
    const [local, setLocal] = useState<AuditTrailFilterValue>(
        DEFAULT_AUDIT_TRAIL_FILTERS,
    );
    const urlValue = useMemo<AuditTrailFilterValue>(
        () => ({
            timeframe:
                (queryParams.timeframe as AuditTrailTimeframeOptions) ??
                DEFAULT_AUDIT_TRAIL_FILTERS.timeframe,
            person:
                (queryParams.person as string) ??
                DEFAULT_AUDIT_TRAIL_FILTERS.person,
        }),
        [queryParams.timeframe, queryParams.person],
    );
    const setFilter = useCallback(
        (field: keyof AuditTrailFilterValue, value: string) => {
            if (mode === 'url') {
                setQueryParams({ [field]: value });
            } else {
                setLocal((prev) => ({ ...prev, [field]: value }));
            }
        },
        [mode, setQueryParams],
    );
    return [mode === 'url' ? urlValue : local, setFilter];
}
